import { useState, useRef, useEffect } from "react";
import { VscClose } from "react-icons/vsc";
import axios from "axios";
import * as securityHelper from "../../helper/SecurityHelper";
import { USER_SESSION } from "../../helper/SecurityHelper";

export default function DelUserCard({
                                      setIsOpenDelUserPop,
                                    }: {
  setIsOpenDelUserPop: (v: boolean) => void;
}) {
  const refPw = useRef<HTMLInputElement | null>(null);
  const user: any = securityHelper.getLoginUser();
  const [warnText, setWarnText] = useState("");

  useEffect(() => {
    if (!warnText) return;
    const t = setTimeout(() => setWarnText(""), 2000);
    return () => clearTimeout(t);
  }, [warnText]);

  const phoneOrUserId = user?.userId || user?.phone;

  const checkPw = async (pw: string) => {
    try {
      const { data } = await axios.post("/admin/api/user/isPwCorrect", {
        phoneOrUserId,
        inputPassword: pw,
      });
      return !!data;
    } catch (e) {
      setWarnText("비밀번호 확인 중 오류가 발생했습니다.");
      return false;
    }
  };

  const fn_withdraw = async () => {
    const pw = refPw.current?.value ?? "";

    if (!pw) {
      setWarnText("비밀번호를 입력해주세요.");
      refPw.current?.focus();
      return;
    }

    const userSeq = user?.seq;
    if (!userSeq) {
      setWarnText("사용자 정보가 올바르지 않습니다. 다시 로그인 해주세요.");
      return;
    }

    const ok = await checkPw(pw);
    if (!ok) {
      setWarnText("기존 비밀번호가 일치하지 않습니다.");
      refPw.current?.focus();
      return;
    }
    if (!window.confirm("회원탈퇴를 계속 진행하시겠습니까?")) return;

    try {
      const { data } = await axios.post("/admin/mem/memDtlModal/deleteMem", {
        userSeq,
      });

      if (!data || Number(data) <= 0) {
        setWarnText("탈퇴에 실패하였습니다.");
        return;
      }

      alert("탈퇴처리 되었습니다.");

      sessionStorage.removeItem(USER_SESSION);

      window.location.href = "/";
    } catch (e) {
      setWarnText("탈퇴 처리 중 오류가 발생했습니다.");
    }
  };

  return (
      <div className="w-full h-[calc(100dvh)] absolute flex justify-center items-center bg-black bg-opacity-[70%] z-40 text-txtBlack">
        <div className="w-[275px] sm:w-[308px] md:w-[750px] h-[380px] md:h-[950px] bg-white rounded-[5px] md:rounded-[12px] flex flex-col items-center">
          {/* header (ChgPswrd랑 동일) */}
          <div className="w-full h-44 md:h-[110px] bg-[#F5F5F5] flex justify-between items-center rounded-t-[5px] md:rounded-t-[12px]">
            <p className="ml-20 text-15 md:ml-[50px] md:text-37 font-preBold">
              회원탈퇴
            </p>
            <VscClose
                onClick={() => setIsOpenDelUserPop(false)}
                className="hover:cursor-pointer mr-15 text-22 md:mr-[37px] md:text-55 md:w-[40px]"
            />
          </div>

          <div className="w-full flex flex-col ml-30 pr-30 rounded-t-[5px] md:ml-[75px] md:rounded-t-[12px]">
            <p className="text-15 mt-20 md:text-37 md:mt-[50px] text-[#dc3545] font-preBold">
              회원 탈퇴를 진행합니다.
            </p>
            <div
                className="mt-10 md:mt-[24px] text-[#6c757d] text-xs md:text-[28px]
             font-preLight leading-relaxed md:leading-[40px]
             whitespace-normal break-words max-w-full"
            >
              <div className="mb-2 md:mb-[14px]">
                □ 회원 탈퇴 시 시스템 이용이 불가능 하며 취소가 불가능 합니다.
              </div>
              {/*<div className="mb-2 md:mb-[14px]">*/}
              {/*  □ 회원 탈퇴 후 마지막 출역 현장의 준공일로 부터 3년 후 까지 정보 보관 후 자동 삭제 됩니다.*/}
              {/*</div>*/}
              <div>□ 회원 탈퇴를 원할 시 비밀번호를 입력해주세요.</div>
            </div>

          </div>

          <div className="w-full flex flex-col ml-30 rounded-t-[5px] md:ml-[75px] md:rounded-t-[12px]">
            <p className="text-15 mt-25 md:text-37 md:mt-[62px]">비밀번호</p>
            <input
                type="password"
                ref={refPw}
                placeholder={"기존 비밀번호를 입력해 주세요."}
                className="w-[255px] sm:w-[274px] md:w-[685px] h-31 mt-5 mb-15 pl-7 md:h-[77px] md:mt-[12px] md:mb-[37px] md:pl-[17px] border border-[#D9D9D9] rounded-[5px] md:rounded-[12px] md:text-37 font-preLight"
            />
          </div>

          {warnText ? (
              <div className="w-[67%] top-2/4 h-44 md:h-[110px] absolute bg-[#2F2F35] flex justify-center items-center text-13 leading-16 md:text-32 md:leading-[40px] font-preLight opacity-80 rounded-[5px] md:rounded-[12px] z-[1000]">
                <p className="text-15 md:text-37 text-white">{warnText}</p>
              </div>
          ) : null}

          <button
              onClick={fn_withdraw}
              className="text-white text-15 md:text-37 font-preLight w-89 h-40 md:w-[222px] md:h-[100px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px]"
          >
            완료
          </button>
        </div>
      </div>
  );
}
